// extracted by mini-css-extract-plugin
export default {"container":"PurchasedItemListView_container__QmQYO","img_view":"PurchasedItemListView_img_view__ooavu","functionGroup":"PurchasedItemListView_functionGroup__CT7hm"};